import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

// Reusable teaser card that promotes the AI Symptom Checker from any page.
// Two flavours: "inline" (default, sits in a section) and "compact" (small
// pill for sidebars / hero corners).

export const SymptomCheckerTeaser = ({ variant = "inline", context = "generic" }) => {
  if (variant === "compact") {
    return (
      <Link
        to="/symptom-checker"
        data-testid={`symptom-teaser-compact-${context}`}
        className="inline-flex items-center gap-2 rounded-full border border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/[0.06] px-3.5 py-1.5 text-[11.5px] uppercase tracking-[0.16em] text-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/[0.12] transition-colors"
      >
        <Sparkles size={12} strokeWidth={1.8} />
        Not sure? Try the 60-sec Symptom Checker
      </Link>
    );
  }

  return (
    <aside
      data-testid={`symptom-teaser-inline-${context}`}
      className="rounded-2xl border border-[hsl(var(--accent))]/25 bg-[hsl(var(--accent))]/[0.05] px-6 py-6 sm:px-8 sm:py-7 flex flex-col sm:flex-row sm:items-center gap-5"
    >
      <div className="flex-1">
        <div className="inline-flex items-center gap-2 text-[10.5px] uppercase tracking-[0.22em] text-[hsl(var(--accent))]">
          <Sparkles size={12} strokeWidth={1.8} /> AI Eye Symptom Checker
        </div>
        <h3 className="mt-3 font-serif text-xl sm:text-2xl leading-tight text-[hsl(var(--foreground))]">
          Not sure how urgent your symptom is? Ask in 60 seconds.
        </h3>
        <p className="mt-2 text-[13px] leading-relaxed text-[hsl(var(--foreground))]/70">
          Educational triage built by our team. Voice input, Hindi mode and photo attach.
          Not a replacement for a physical consultation.
        </p>
      </div>
      <Link to="/symptom-checker" className="btn-primary shrink-0" data-testid={`symptom-teaser-cta-${context}`}>
        Try the Checker <ArrowRight size={15} strokeWidth={1.7} />
      </Link>
    </aside>
  );
};

export default SymptomCheckerTeaser;
